import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { AffiliatesComponent } from './Components/affiliates/affiliates.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { TryADemoComponent } from './Components/try-ademo/try-ademo.component';
import { ProfessionalEditingServiceComponent } from './Components/professional-editing-service/professional-editing-service.component';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';
import { GrammarCheckerFeaturesComponent } from './Components/features/grammar-checker-features/grammar-checker-features.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { InclusiveLanguageReportComponent } from './Components/features/inclusive-language-report/inclusive-language-report.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { LegalWritingComponent } from './Components/features/legal-writing/legal-writing.component';
import { AIAppsLibraryComponent } from './Components/features/ai-studio/aiapps-library/aiapps-library.component';
import { AskTrinkaComponent } from './Components/features/ai-studio/ask-trinka/ask-trinka.component';
import { DataSensitivePlanComponent } from './Components/enterprise/data-sensitive-plan/data-sensitive-plan.component';
import { AIContentDetectorFeaturesComponent } from './Components/features/aicontent-detector-features/aicontent-detector-features.component';
import { CitationFormatterComponent } from './Components/features/citation-formatter/citation-formatter.component';
import { JournalFinderComponent } from './Components/features/journal-finder/journal-finder.component';
import { WindowsDesktopAppComponent } from './Components/windows-desktop-app/windows-desktop-app.component';
import { WordPluginLiteComponent } from './Components/word-plugin-lite/word-plugin-lite.component';
import { OnPremiseGrammarCheckerComponent } from './Components/enterprise/on-premise-grammar-checker/on-premise-grammar-checker.component';
import { CustomAIModelsComponent } from './Components/enterprise/custom-aimodels/custom-aimodels.component';
import { HowWeDoItComponent } from './Components/enterprise/custom-aimodels/how-we-do-it/how-we-do-it.component';
import { ProcessModelComponent } from './Components/enterprise/custom-aimodels/process-model/process-model.component';
import { WhyChooseUsComponent } from './Components/enterprise/custom-aimodels/why-choose-us/why-choose-us.component';
import { RLHFComponent } from './Components/enterprise/custom-aimodels/rlhf/rlhf.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { JournalFinderToolsPageComponent } from './Components/journal-finder-tools-page/journal-finder-tools-page.component';
import { AcademicPhrasebankComponent } from './Components/academic-phrasebank/academic-phrasebank.component';
import { AcademicPhrasebankBrowseComponent } from './Components/academic-phrasebank-browse/academic-phrasebank-browse.component';
import { EnterpriseFormPageComponent } from './Components/enterprise-form-page/enterprise-form-page.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "features",
    component: FeaturesComponent,
  },
  {
    path: "examples",
    component: ExamplesComponent,
  },
  {
    path: "pricing",
    component: PricingComponent,
  },
  {
    path: "enterprise",
    component: EnterpriseComponent,
  },
  { path: "enterprise/life-sciences-medicine-and-pharma", component: LifeSciencesMedicineAndPharmaComponent },
  { path: "enterprise/language-services-publishing-and-media", component: LanguageServicesPublishingAndMediaComponent },
  { path: "enterprise/academic-institutions", component: AcademicInstitutionsComponent },
  { path: "enterprise/k12-and-elearning", component: K12AndElearningComponent },
  { path: "enterprise/technology-platforms", component: TechnologyPlatformsComponent },
  { path: "features/consistency-check", component: ConsistencyChecksComponent },
  { path: "features/personal-dictionary", component: PersonalDictionaryComponent },
  { path: "features/publication-readiness-checks", component: PublicationChecksComponent },
  { path: "features/proofread-file", component: AutoEditComponent },
  { path: "features/credits", component: CreditsComponent },
  { path: "features/plagiarism-check", component: PlagiarismCheckerComponent },
  { path: "features/documark", component: DocumarkComponent },
  { path: "features/grammar-checker", component: GrammarCheckerFeaturesComponent },
  { path: "features/latex-grammar-checker", component: LatexGrammarCheckerComponent },
  { path: "features/inclusive-language-check", component: InclusiveLanguageReportComponent },
  { path: "features/paraphraser", component: OnlineParaphraserComponent },
  { path: "features/legal-writing", component: LegalWritingComponent },
  { path: "features/ai-studio/ai-writing-tools", component: AIAppsLibraryComponent },
  { path: "features/ai-studio/ai-assisted-writing", component: AskTrinkaComponent },
  { path: "features/ai-content-detector", component: AIContentDetectorFeaturesComponent },
  { path: "features/citation-formatter", component: CitationFormatterComponent },
  { path: "features/journal-finder", component: JournalFinderComponent },
  { path: "punctuation-checker", component: PunctuationCheckerComponent },
  { path: "spell-checker", component: SpellCheckerComponent },
  { path: "sentence-checker", component: SentenceCheckerComponent },
  { path: "enterprise/grammar-checker-api", component: APIComponent },
  { path: "enterprise/sensitive-data-plan", component: DataSensitivePlanComponent },
  { path: "enterprise/on-premise-grammar-checker", component: OnPremiseGrammarCheckerComponent },
  { path: "enterprise/custom-ai-models/overview", component: CustomAIModelsComponent },
  { path: "enterprise/custom-ai-models/how-we-do-it", component: HowWeDoItComponent },
  { path: "enterprise/custom-ai-models/process", component: ProcessModelComponent },
  { path: "enterprise/custom-ai-models/why-choose-us", component: WhyChooseUsComponent },
  { path: "enterprise/custom-ai-models/rlhf", component: RLHFComponent },
  { path: "enterprise/inquiry", component: EnterpriseFormPageComponent},
  { path: "ai-content-detector", component: AiDetectorToolComponent },
  { path: "journal-finder", component: JournalFinderToolsPageComponent },
  {
    path: "wordplugin",
    component: wordpluginComponent,
  },
  {
    path: "trinkacloud",
    component: TrinkaCloudComponent,
  },
  {
    path: "windows-desktop-app",
    component: WindowsDesktopAppComponent,
  },
  {
    path: "wordplugin-lite",
    component: WordPluginLiteComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent
  },
  {
    path: "contactus",
    component: ContactUsComponent,
  },
  {
    path: "workwithus",
    component: WorkWithUsComponent,
  },
  {
    path: "privacypolicy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "termsofservices",
    component: TermServicesComponent,
  },
  // {
  //   path: "try-a-demo",
  //   component: GcEditorComponent,
  // },
  {
    path: "try-a-demo",
    component: TryADemoComponent,
  },
  {
    path: "auto-edit",
    component: AutoEditComponent,
  },
  {
    path: "affiliates",
    component: AffiliatesComponent,
  },
  {
    path: "browser-plugin",
    component: BrowserPluginComponent,
  },
  {
    path: "publication-check",
    component: PublicationChecksComponent,
  },
  {
    path: "professional-editing-service",
    component: ProfessionalEditingServiceComponent,
  },
  { path: "paraphrasing-tool", component: ParapharsingToolComponent },
  { path: "trinka-vs-grammarly", loadChildren: () => import('./modules/trinkavsgrammarly.module').then(m => m.TrinkaVsGrammarlyModule)},
  { path: "trinka-vs-ginger", component: TrinkaVsGingerComponent },
  { path: "trinka-vs-languagetool", component: TrinkaVsLanguagetoolComponent },
  { path: "trinka-vs-writefull", component: TrinkaVsWritefullComponent },
  { path: "grammar-checker", component: GcEditorComponent },
  { path: "faqs", component: FAQComponent },
  { path: "features/citation-checker", component: CitationCheckerComponent },
  { path: "citation-checker/sample-report", component: CitationSampleReportComponent },
  { path: "academic-phrasebank", component: AcademicPhrasebankComponent },
  { path: "academic-phrasebank-browse/:topic/:subtopic", component: AcademicPhrasebankBrowseComponent },
  { path: "data-security", loadChildren: () => import('./modules/datasecurity.module').then(m => m.DataSecurityModule)},
  { path: "news",  loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule)},
  { path: "local-invoice", loadChildren: () => import('./modules/officialinvoice.module').then(m => m.OfficialInvoiceModule)},
  { path: "trinka-vs-grammarly-vs-language-tool", loadChildren: () => import('./modules/whitepaper/whitepaper.module').then(m => m.WhitepaperModule)},
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
